import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";

import { DealerOrganization, PaginatedResult } from "src/common/types";
import { useKy } from "src/common/ky";

export const useDealersQuery = () => {
  const ky = useKy();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  if (!searchParams.has("pageNumber")) {
    searchParams.set("pageNumber", "1");
  }

  searchParams.sort();

  return useQuery<PaginatedResult<DealerOrganization>>(
    ["DEALER_ORGANIZATIONS", searchParams.toString()],
    () =>
      ky
        .get(`dealer-organizations`, { searchParams })
        .json<PaginatedResult<DealerOrganization>>()
  );
};
